<template>
  <v-layout
    :class="{ 'module-selected': selected }"
    class="new-module-container"
    column
    @click="$emit('click')"
  >
    <div>
      <div class="content">
        <div class="checkbox-wrapper">
          <v-icon
            slot="activator"
            :color="selected ? 'primary' : '#666'"
            icon
            class="new-module-icon"
            :class="{ selected: selected }"
          >
            add_circle
          </v-icon>
        </div>
        <div>
          <h2 class="moduleTitle" :class="{ 'selected-text-color': selected }">
            {{ title }}
          </h2>
          <p class="new-module-description" :class="{ 'selected-text-color': selected }">
            {{ text }}
          </p>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'new-module',
  props: {
    title: String,
    text: String,
    selected: Boolean,
  },
}
</script>

<style>
.new-module-container {
  display: flex;
  gap: 0.625rem;
  width: 100%;
  background: #ffffff;
  border: 0.125rem solid #d9d9d9;
  border-radius: 0.5rem;
}

.new-module-container:hover {
  background-color: rgba(2, 119, 189, 0.1);
  cursor: pointer;
}

.module-selected {
  border: 0.125rem solid #0277bd !important;
}

.selected-text-color {
  color: #0277bd !important;
}

.new-module-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #666666;
}

.new-module-icon {
  margin-right: 0.75rem;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  cursor: pointer;
}

.moduleTitle {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  color: #666666;
}
.selected {
  transform: rotate(-45deg);
}
.content {
  display: flex;
  flex-direction: row;
  height: fit-content;
  padding: 1.5rem;
}
</style>
